export const abc = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
];

export const getLetter = (i) => {
    return abc[i];
};

export const convertUnicode = (input) => {

    try{

        let inputString = input.toString();
        if (inputString.length > 0) {
            return inputString.replace(/\\u(\w\w\w\w)/g, function (a, b) {
                var charcode = parseInt(b, 16);
                return String.fromCharCode(charcode);
            });
        }
    }catch(e){
        return "";
    }
};

export const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("username");
};

export const setWithExpiry = (key, value, ttl) => {
    const now = new Date();
    const item = {
        value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
};

export const removeWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }
    let item = null;
    try {
        item = JSON.parse(itemStr);
    } catch (error) {
        item = null;
    }

    if (item !== null) {
        // const item = JSON.parse(itemStr)
        const now = new Date();

        // console.log('Tiempo de expiracion: ', item.expiry)
        // console.log('Tiempo actual: ', now.getTime())
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);

            logout();
            return null;
        }
    }

    return item;
};

export const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
